








































import {Component, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import {ActiveProvide} from "@/support/reactive"
import {Location, RouteConfig} from "vue-router"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdhAttachedModalPopup from "@/design-system/shared/JdhAttachedModalPopup.vue"
import JdhSneakPeek from "@/design-system/shared/JdhSneakPeek.vue"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog 4.17.0 Add exact-path.
 * @changelog 5.0.0 Add disabled mode and hint.
 * @changelog 6.5.5 Add support for external links.
 */
@Component({
    components: {JdhSneakPeek, JdhAttachedModalPopup, JdsGlyph, JdsIcon}
})
export default class JdsNavigatorItem extends Vue {
    @Prop({default: "medium"}) size!: string;
    @Prop() to!: Location | string;
    @Prop() icon!: string;
    @Ref() anchorEl!: HTMLElement

    showDisabledTooltip = false

    /**
     * Passed into the router-link as the `exact` prop.
     */
    @Prop({type: Boolean, default: false}) exact!: boolean;

    @Prop({type: Boolean, default: false}) disabled!: boolean;


    /**
     * Passed into the router-link as the `exact-path` prop.
     */
    @Prop({type: Boolean, default: false}) exactPath!: boolean;

    @ActiveProvide('jds.navigator.item.active') active = false;

    @Watch('$route', {immediate: true})
    updateActive () {
        this.active = this.$route.matched.some(({name}) => typeof this.to === 'object' && this.to.name === name);
    }

    get linkComponent() {
        if (this.disabled) {
            return 'div';
        }

        if (typeof this.to === 'string' && this.to.startsWith('https://')) {
            return 'a';
        }

        return 'router-link';
    }

    get linkProps() {
        const props: Record<string, any> = {};

        if (typeof this.to === 'string' && this.to.startsWith('https://')) {
            props.href = this.to;
        } else {
            props.to = this.to;
        }

        return props;
    }
}
